var browser = {
  chrome: false,
  firefox: false,
  opera: false,
  edge: false,
  safari: false
}

export function getBrowser() {
  let userAgent = navigator.userAgent.toLowerCase()
  let browserM = userAgent.match(/(opera|chrome|safari|firefox|msie|edge|fxios|crios)[/\s]*([\d.]+)/)
  let browserLocal = navigator.appName.toLowerCase()
  if (browserM) {
    browserLocal = browserM[1]
  }
  browser.chrome = (browserLocal === 'chrome')
  browser.firefox = (browserLocal === 'firefox')
  browser.safari = (browserLocal === 'safari')
  browser.opera = (navigator.userAgent.match(/Opera|OPR\//) !== null)
  if (browser.opera) {
    browser.chrome = false
  }
  if (navigator.userAgent.indexOf('Edge') >= 0) {
    let pos = navigator.userAgent.indexOf('Edge')
    let version = navigator.userAgent.substr(pos + 5, 2)
    //if (version > 16) {
    browser.edge = false
    browser.chrome = false
    browser.firefox = false
    browser.opera = false
    browser.safari = false
    //}
  }
  if (browserLocal === 'safari' && navigator.userAgent.indexOf('Version') >= 0) {
    let pos = navigator.userAgent.indexOf('Version/')
    let version = navigator.userAgent.substr(pos + 8, 2)
    if (version > 11) {
      browser.edge = false
      browser.chrome = false
      browser.firefox = false
      browser.opera = false
      browser.safari = true
    }
  }
  return browser
}

export function isMobile () {
  return !!navigator.userAgent.match(/iPhone|iPad|iPod|Android/i) ? true : false
}

export function isIos(){
  if (!!navigator.userAgent.match(/iPhone|iPad|iPod/i) && browser.safari) {
    return true
  } else {
    return false
  }
}

export function versionOfIos() {
  let d, v
  if (/iP(hone|od|ad)/.test(navigator.platform)) {
    v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/)
    d = {
      status: true,
      version: parseInt(v[1], 10) ,
      info: parseInt(v[1], 10)+'.'+parseInt(v[2], 10)+'.'+parseInt(v[3] || 0, 10)
    }
  }else{
    d = {status:false, version: false, info:''}
  }
  return d
}

export function isSupported () {
  if (!!navigator.userAgent.match(/iPhone|iPad|iPod/i) && !browser.safari) {
    return false
  }
  if (browser.chrome || browser.firefox || browser.edge || browser.opera || browser.safari) {
    return true
  } else {
    return false
  }
}

export function isSupportedShare () {
  if ((browser.chrome || browser.firefox || browser.edge) && !isMobile()) {
    return true
  } else {
    return false
  }
}


// WEBPACK FOOTER //
// ./src/functions/browserDetails.js